import { compose, defaultTo, isNil, not, propOr } from 'ramda';
import { dotPath as getInPath } from 'ramda-extension';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';
import { defaultFetchState } from './model';

export const getFetchStore = (state) => state[NAME];

export const getFetchState = (path) => compose(defaultTo(defaultFetchState), getInPath(path), getFetchStore);

const getFetchProp = (path, prop) => compose(propOr(EMPTY_VALUES.OBJECT, prop), getFetchState(path));

export const getMetaData = (path) => getFetchProp(path, 'metaData');

export const getLastRequest = (path) => getFetchProp(path, 'lastRequest');

export const getIsFetching = (path) => getFetchProp(path, 'isFetching');

export const getIsLoaded = (path) => getFetchProp(path, 'loaded');

export const getWasFetched = (path) => compose(not, isNil, getInPath(path), getFetchStore);
